import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  ACCESS_DECISION_DENIED_MESSAGE,
  ACCESS_DECISION_ROUTES,
} from '../../../Consts/access-decision.const';
import { AccessDecision } from '../../../Types/access-decision.type';
import { AuthTokenService } from './auth-token.service';

@Injectable({
  providedIn: 'root',
})
export class AccessDecisionRouterService {
  private readonly _router = inject(Router);
  private readonly _authTokenService = inject(AuthTokenService);
  private readonly _unreachable = new Set<AccessDecision>();

  public resolveTokenRoute(): string | null {
    return this.routeFor(this._authTokenService.getAccessDecision());
  }

  public redirectOnDenial(error: HttpErrorResponse): boolean {
    const decision = this.resolveDecision(error);

    if (!decision || this._unreachable.has(decision)) {
      return false;
    }

    const route = this.routeFor(decision);

    if (!route) {
      return false;
    }

    if (this.currentPath() !== route) {
      this.navigate(decision, route);
    }

    return true;
  }

  private routeFor(decision: AccessDecision | null): string | null {
    return decision ? (ACCESS_DECISION_ROUTES[decision] ?? null) : null;
  }

  private resolveDecision(error: HttpErrorResponse): AccessDecision | null {
    if (error.status !== 403 || error.error?.message !== ACCESS_DECISION_DENIED_MESSAGE) {
      return null;
    }

    const decision: AccessDecision | undefined = error.error?.data?.access_decision;

    return decision ?? null;
  }

  private navigate(decision: AccessDecision, route: string): void {
    void this._router.navigateByUrl(route).then((landed) => {
      if (!landed) {
        this._unreachable.add(decision);
      }
    });
  }

  private currentPath(): string {
    return this._router.url.split('?')[0];
  }
}
